import { useLayoutEffect, useRef, useState } from "react";

const TABLE_CHROME = 114;

export const useTableBodyHeight = () => {
  const tableRef = useRef<HTMLDivElement>(null);
  const paginationRef = useRef<HTMLDivElement>(null);
  const [bodyHeight, setBodyHeight] = useState<number>(400);

  useLayoutEffect(() => {
    let timer: ReturnType<typeof setTimeout>;

    const measure = () => {
      const tableEl = tableRef.current;
      const pagEl = paginationRef.current;
      if (!tableEl) return;
      const tableTop = tableEl.getBoundingClientRect().top;
      const pagHeight = pagEl ? pagEl.getBoundingClientRect().height : 0;
      setBodyHeight(window.innerHeight - tableTop - TABLE_CHROME - pagHeight);
    };

    const update = () => {
      clearTimeout(timer);
      timer = setTimeout(measure, 100);
    };

    measure();
    const ro = new ResizeObserver(update);
    ro.observe(document.documentElement);
    window.addEventListener("resize", update);
    return () => {
      clearTimeout(timer);
      ro.disconnect();
      window.removeEventListener("resize", update);
    };
  }, []);

  return { tableRef, paginationRef, bodyHeight };
};
